import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { userAccessToken } from "../helpers";

export const fetchErrorLogs = (filter) => {
  const {
    account_id,
    page,
    per_page,
    search_term,
    order_by,
    start_date,
    end_date,
  } = filter;

  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
  let startDateParam = start_date ? `&start_date=${start_date}` : "";
  let endDateParam = end_date ? `&end_date=${end_date}` : "";

  return axios.get(
    `${apiServicesUrl}/logs/client-error-logs?account_id=${account_id}&page=${page}&per_page=${per_page}${searchParam}${startDateParam}${endDateParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const fetchIndividualError = async (
  account_id,
  error_id,
) => {
  let errorId = error_id ? `&id=${error_id}` : "";
  try {
    const response = await axios.get(
      `${apiServicesUrl}/logs/single-client-error-log?account_id=${account_id}${errorId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};
